import { Button, message } from "antd";
import { capitalize } from "lodash";
import { Link } from "react-router-dom";
import { useAppSelector } from "../../../../../app/store";
import CopyIcon from "../../../../../assets/icons/CopyIcon";
import FlagIcon from "../../../../../assets/icons/FlagIcon";
import { formatValue } from "../../../../../utils/string";
import { formatSLA } from "../../../../../utils/utils";
import { PRIORITY_CONFIG } from "../AllTickets";

interface TicketApprovalHubCardProps {
  ticket: any;
}

export default function AssignedTicketCard({
  ticket,
}: TicketApprovalHubCardProps) {
  const userRole = useAppSelector((state) => state.auth.role);
  // const [dropdownOpen, setDropdownOpen] = useState(false);
  // const { handleOpen, handleClose, open } = useModal<
  //   any | undefined,
  //   "UPDATE"
  // >();
  const handleCopy = () => {
    const textToCopy = ticket?.generated_ticket_log_id;
    if (textToCopy) {
      navigator.clipboard.writeText(textToCopy).then(() => {
        message.success(`Copied: ${textToCopy}`);
      });
    }
  };

  return (
    <>
      {/* {open.type === "UPDATE" && (
        <ShiftPriorityModal
          open={open.open}
          handleClose={handleClose}
          data={open.data}
        />
      )} */}

      <div className="bg-white p-4 border border-[#D7DFE9] rounded-md flex flex-col justify-between min-h-[278px] gap-3">
        <div className="space-y-2">
          <div className="flex justify-between">
            <div className="text-[#455468] text-[20px]">{ticket?.title}</div>
            {/* <div>
              {ticket?.workflow_status !== "closed" &&
              ticket?.workflow_status !== "canceled" ? (
                <Dropdown
                  open={dropdownOpen}
                  onOpenChange={setDropdownOpen}
                  placement="bottomRight"
                  dropdownRender={() => (
                    <div
                      className="flex gap-2 items-center bg-white rounded-md p-2 shadow cursor-pointer"
                      onClick={() => {
                        handleOpen({
                          type: "UPDATE",
                          data: {
                            priority: ticket?.priority,
                            id: ticket?.id,
                          },
                        });
                        setDropdownOpen(false);
                      }}
                    >
                      <span>
                        <ShiftPriorityIcon />
                      </span>
                      <span>Shift Priority</span>
                    </div>
                  )}
                  trigger={["click"]}
                >
                  <div className="cursor-pointer">
                    <ThreeDotsIcon />
                  </div>
                </Dropdown>
              ) : null}
            </div> */}
          </div>
          <div className="flex gap-2 items-center">
            <span>{ticket?.generated_ticket_log_id}</span>
            <span className="cursor-pointer" onClick={handleCopy}>
              <CopyIcon />
            </span>
          </div>

          <div className="my-4 flex gap-2">
            <div className="status status-primary">
              {capitalize(ticket?.role_type)}
            </div>

            <div className="status status-orange">
              {formatSLA(ticket?.totalSLA)}
            </div>

            {ticket.priority && (
              <span
                className={`flex items-center gap-1 ${
                  PRIORITY_CONFIG?.[
                    ticket?.priority as keyof typeof PRIORITY_CONFIG
                  ].className
                }`}
              >
                <FlagIcon />
                {formatValue(
                  PRIORITY_CONFIG?.[
                    ticket?.priority as keyof typeof PRIORITY_CONFIG
                  ].title,
                )}
              </span>
            )}
          </div>

          <p className=" text-display-body">{ticket?.description}</p>
        </div>
        <Link
          to={`${
            userRole === "super_admin" || userRole === "Admin"
              ? "/admin"
              : "/user"
          }/ticket-management/approval-hub/approver-details/${
            ticket?.generated_ticket_log_id
          }`}
        >
          <Button className="button-bordered-light" block>
            View Ticket
          </Button>
        </Link>
      </div>
    </>
  );
}
